const codes = require('./codes.json');

module.exports = (fen) => codes[fen];
